jQuery(document).ready(function ($) {
	"use strict";
		let body = $('.blog_posts');
		let data = {};
		let offset = 4;
		let per_page = 4;
		$(document).on('click', '.js-load-more', function () {
			let button = $(this);
			if( button.hasClass('cases_more') ) {
				let industry = [];
				let service = [];
				let technology = [];
				$('.cases__filter-list[data-name=Industry] span.active').each(function(){
				  industry.push( $(this).data('id') );
				})
				$('.cases__filter-list[data-name=Service] span.active').each(function(){
				  service.push( $(this).data('id') );
				})
				$('.cases__filter-list[data-name=Technology] span.active').each(function(){
				  technology.push( $(this).data('id') );
				})
				data = {				
					action: 'loadmore',				
					offset: offset,
					per_page: per_page,
					post_type: 'case',
					industry: industry,
					service: service,
					technology: technology
				}
			}else{
				let category_button = $('.blog__category.active'), cat = category_button.data('cat');
				data = {					
					action: 'loadmore',				
					offset: offset,
					per_page: per_page,
					post_type: 'post',
					category : cat
				};
			}
			$.ajax({
				url: wpApiSettings.ajaxUrl,
				type: 'POST',
				data: data,
				beforeSend: (xhr) => {
					if (button) {
						button.addClass('loading');
						button.find('a').addClass('is-disabled');
					}
				},
				success: (response) => {
					if (button) {
						button.find('a').removeClass('is-disabled');
						button.addClass('is-active').removeClass('loading');
						body.append(response.data.content);
						if( ! response.data.button ){
							button.hide();
						}else{
							button.show();
						}
					}
					offset = offset + per_page;
				},
				error: (error) => {
					console.log(error);
				}
			});
		});
		
		$(document).on('click', '.blog__category', function () {
			let button = $(this);
			let offset = 0;
			$('.blog__category.active').removeClass('active');
			button.addClass('active');
			let cat = button.data('cat');
			let newSlug = cat ? button.attr('href') : $('.blog__category:first-child()').attr('href');
            history.pushState({}, "", newSlug);
			let data = {
				action: 'loadmore',
				category: cat,
				offset: offset,
				per_page: per_page,
				post_type: 'post'
			};
			$.ajax({
				url: wpApiSettings.ajaxUrl,
				type: 'POST',
				data: data,
				success: (response) => {
					body.html(response.data.content);
					if( ! response.data.button ){
						$('.js-load-more').hide();
					}else{
						$('.js-load-more').show();
					}
				},
				error: (error) => {
					console.log(error);
				}
			});
			return false;
		});
});